import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale, useUserContentItems } from 'pe-core-frontend';
import customStyles from './CustomContent.module.scss';
export const ContentPanel = (props) => {
    const { t } = useLocale();
    const userContentItemsData = useUserContentItems({
        code: props.code,
        locale: 'en_US', // Always request English content; Weglot handles translation on the frontend
        clientId: props.clientId,
    });
    return (_jsxs("div", { className: 'flex flex-col gap-5', children: [userContentItemsData.loading && _jsx("div", { children: t('Loading content...') }), !userContentItemsData.loading &&
                userContentItemsData.items &&
                userContentItemsData.items.map(item => (_jsx("div", { children: _jsxs("div", { children: [!props.hideTitle && item.title && _jsx("div", { className: 'text-2xl', children: item.title }), _jsx("div", { className: customStyles.customContent, dangerouslySetInnerHTML: {
                                    __html: item.value,
                                } })] }) }, item.id)))] }));
};
